// extracted by mini-css-extract-plugin
module.exports = {"dataPoint":"_13NP1___DataPoint-module__dataPoint"};